import { Ziggy } from '@/modules/shared/helpers/facades/ziggy'
import { vsingleton } from '@niknevis/vue-modules'
import { Config } from '@niknevis/vue-modules/config'

@vsingleton()
export class LayoutRoute {
  public userType: string = Config.get('userType')

  get boot() {
    return Ziggy.route(`panel.api.boot`).toString()
  }
}